<div class="page-content">
    <div class="page-header">
        <h1>{{ title }}</h1>
        <div class="page-description">{{ subTitle }}</div>
    </div>
    <div class="page-body">
        <div class="container-fluid cards-container">
            @let kpi = kpis()[0];
            <div class="row g-3">
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.claimCount.title"
                        [body]="{
                            value: kpi.claimCount,
                            precision: texts.claimCount.precision,
                        }"
                        [badge]="{
                            value: kpi.claimCountEvolution,
                            suffix: texts.claimCount.badge.suffix,
                            precision: texts.claimCount.badge.precision,
                            style: kpi.claimCountEvolution! > 0 ? 'success' : 'danger',
                        }"
                        [descriptionTitle]="texts.claimCount.description.title"
                        [descriptionContent]="texts.claimCount.description.content"
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'claimCount', 'claimCountEvolution')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.treatedClaimRate.title"
                        [body]="{
                            value: kpi.treatedClaimRate,
                            precision: texts.treatedClaimRate.precision,
                            suffix: texts.treatedClaimRate.suffix,
                        }"
                        [badge]="{
                            value: kpi.treatedClaimRateEvolution,
                            suffix: texts.treatedClaimRate.badge.suffix,
                            precision: texts.treatedClaimRate.badge.precision,
                            style: kpi.treatedClaimRateEvolution! > 0 ? 'success' : 'danger',
                        }"
                        [isLoading]="!kpi.organizationId"
                        [error]="
                            checkKpiErrors(kpi, 'treatedClaimRate', 'treatedClaimRateEvolution')
                        "
                        cardClass="h-100">
                    </kpi-card>
                </div>
            </div>

            <chart-card
                id="evolComplaintsEdf"
                [title]="texts.evolcomplaintsEdfChart.title"
                [error]="complChartError"
                [isLoading]="!complChartData()[0].organizationId"
                [series]="complChartSeries"
                [dataLabels]="complDataLabels"
                [stacked]="true"
                [yaxis]="complYaxis"
                [xaxisCategories]="complXaxisCategories"
                [precision]="texts.evolcomplaintsEdfChart.precision"
                [xaxisTitle]="texts.evolcomplaintsEdfChart.xaxisTitle"
                [legend]="complLegend"
                [customTooltip]="evolComplaintsCustomTooltip"
                class="h-100">
            </chart-card>

            <div class="row">
                <div class="col-sm-12 col-lg-6">
                    <chart-card
                        id="distribComplaintsEdfChart"
                        [title]="texts.distribComplaintsEdfChart.title"
                        [error]="distribChartError"
                        [isLoading]="!distribChartData()[0].organizationId"
                        [series]="distribChartSeries"
                        [dataLabels]="distribDataLabels"
                        [stacked]="true"
                        [yaxis]="distribYaxis"
                        [xaxisCategories]="distribXaxisCategories"
                        [precision]="texts.distribComplaintsEdfChart.precision"
                        [xaxisTitle]="texts.distribComplaintsEdfChart.xaxisTitle"
                        [unitTooltip]="texts.distribComplaintsEdfChart.unitTooltip"
                        class="h-100">
                    </chart-card>
                </div>
                <div class="col-sm-12 col-lg-6">
                    <chart-card
                        id="evolRateComplaintsEdfChart"
                        [title]="texts.evolRateComplaintsEdfChart.title"
                        [error]="rateChartError"
                        [isLoading]="!rateChartData()[0].organizationId"
                        [series]="rateChartSeries"
                        [dataLabels]="rateDataLabels"
                        [stacked]="true"
                        [yaxis]="rateYaxis"
                        [xaxisCategories]="rateXaxisCategories"
                        [precision]="texts.evolRateComplaintsEdfChart.precision"
                        [xaxisTitle]="texts.evolRateComplaintsEdfChart.xaxisTitle"
                        [plotOptions]="ratePlotOptions"
                        class="h-100">
                    </chart-card>
                </div>
            </div>

            <chart-card
                id="edfClaimRateComparisonChart"
                [title]="texts.edfClaimRateComparisonChart.title"
                [descriptionTitle]="texts.edfClaimRateComparisonChart.descriptionTitle"
                [descriptionContent]="texts.edfClaimRateComparisonChart.descriptionContent"
                [error]="edfClaimRateComparisonChartError"
                [isLoading]="!edfClaimRateComparisonChartDataSignal()[0].organizationId"
                [type]="'rangeBar'"
                [dataLabels]="rateComparisonDataLabels"
                [series]="edfClaimRateComparisonChartSeries"
                [plotOptions]="rateComparisonPlotOptions"
                [customTooltip]="rateComparisonCustomTooltip"
                cardClass="h-100"></chart-card>

            <geo-map-card
                [title]="texts.edfClaimRateMap.title"
                [descriptionContent]="texts.edfClaimRateMap.descriptionContent"
                [descriptionTitle]="texts.edfClaimRateMap.descriptionTitle"
                [geometries]="geometries()"
                [isLoading]="!geometries()[0].organizationId"
                [error]="!!geometries()[0].error"
                [getStyle]="getMapStyle"
                [legendConfig]="legendConfig"
                [mapId]="'edfClaimRateMap'"
                [getTooltip]="getTooltip"></geo-map-card>
        </div>
    </div>
</div>
